import axios from 'axios';

export async function getAccounts(query = {}) {
  const response = await axios.get('/accounts', query);
  return response.data;
}

export async function inactivateAccount(id) {
  const response = await axios.put(`/accounts/${id}/inactivate`);
  return response.data;
}

export async function activateAccount(id) {
  const response = await axios.put(`/accounts/${id}/activate`);
  return response.data;
}

// #521 — ação separada de activateAccount/inactivateAccount: religa SÓ o
// login do titular (user.active), nunca o account.status. `motivo` é
// obrigatório (override administrativo auditado).
export async function ativarLoginTitular(id, motivo) {
  const response = await axios.put(`/accounts/${id}/ativar-login-titular`, { motivo });
  return response.data;
}

export async function createAccount(data) {
  const response = await axios.post('/accounts', data);
  return response.data;
}

export async function subscribe(data) {
  const response = await axios.post('/subscription', data);
  return response.data;
}
